<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @search="search" @reflash="reflash" @exps="exps" @save="save" ref="SetBtn"></buttonlist>
		<el-tabs :tab-position="'top'" type="">
			<el-tab-pane :label="$t('getapi[945]')" name="0">
				<wTable
						id="xpane-0"
						:data="dataSet"
						:loading="loading"
						queryData="InvissueManufactureLineInfo"
						:filter_language="['Order_status','Negative_Flag']"
						:filter_thousandth="['plan_qty','actually_qty','assign_qty','return_qty','Unit_Price','Line_Net_Total_Amount','assist_plan_qty']"
						:header="tableHeader"
						:option="tableOption"
						ref="singleTable"
						:checkflg="false"
				></wTable>
				<!--<el-table
						:data="dataSet"
						v-loading="loading"
						:highlight-current-row="true"
						show-overflow-tooltip="true"
						border
						stripe
						size="mini"
						:height="tableHeight"
						header-row-class-name="headerclass"
						style="width: 100%; margin-top:0px"
				>
					<el-table-column type="selection" v-if="false"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Order_No" :label="$t('getapi[2095]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Order_status" :label="$t('getapi[552]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="issue_type" :label="$t('getapi[2177]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="keep_account_No" :label="$t('getapi[2098]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="model" :label="$t('getapi[124]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="specification" :label="$t('getapi[125]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_stuff" :label="$t('getapi[126]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="plan_qty" align="right" :label="$t('getapi[2182]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="actually_qty"  align="right" :label="$t('getapi[2183]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="assign_qty"  align="right" :label="$t('getapi[2184]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="return_qty" align="right" :label="$t('getapi[2185]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="MeasureUnit" :label="$t('getapi[888]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="issue_person" :label="$t('getapi[2178]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="issue_time" :label="$t('getapi[2179]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="keep_account_person" :label="$t('getapi[2103]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="keep_account_time" :label="$t('getapi[1748]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Line_Net_Total_Amount" :label="$t('getapi[2186]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Unit_Price" :label="$t('getapi[2187]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Issue_Dept" :label="$t('getapi[2180]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="customer_code" :label="$t('getapi[2610]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[876]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="item_name" :label="$t('getapi[546]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[1509]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Negative_Flag" :label="$t('getapi[2096]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="assist_plan_qty" :label="$t('getapi[2364]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="assist_measureunit" :label="$t('getapi[130]')"></el-table-column>
				</el-table>-->
			</el-tab-pane>
			<el-row class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
		</el-tabs>
		<serce :isVisible="isVisible" queryData="InvissueManufactureLineInfo" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[977]')" queryData="InvissueManufactureLineInfo" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>
		<!-- 详情页面 -->
		<purordermanage :isVisible="isVisible" ref="order" @getdetail="getdetail"></purordermanage>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'InvOutDetailView',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3 - Common.reduceTableHeight2
        }
    },
	data() {
		return {
            tableHeader: [],
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('InvOutDetailView'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			dataDetail: {
				Head: {},
				Lists: []
			}, // 编辑页面数据详情
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	mounted: function() {
		let that = this;
        that.colsort();
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
	},
	methods: {
        colsort() {
            let that = this;
            that.$loadviewfields.Fileds('InvissueManufactureLineInfo', 0, PFileds => {
                that.tableHeader = PFileds;
            });
        },
        sortclick(val) {
            if (val == 1) {
                this.colsort();
            }
        },
        // 修改表格顺序
        opentable() {
            this.$refs.ctab.clearInputs(true);
        },
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[977]"),this.$t("getapi[15]"));
        },
		//type 1 一览权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
			//只读权
			if (that.$limits.ReadOnlyRightsView('plv2', 96, 1, that.total)) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			}
			//操作权限-查询级别
			var limits = that.$limits.OperationAuthorityView('plv2', 96, 1, that.total);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (limits) {
				case -1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				default:
					break;
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('InvOutDetailView',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'InvissueManufactureLineInfo');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
			that.isVisible = false;
			that.pageIndex = 1;
			that.pageSize = 100;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			that.$http.urlpost('/Inv/UniversalOut/DataList_Detail', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
				}
				that.authority();
			});
		},
		// 根据ID获取详情数据
		editInfo(row) {
			let that = this;
			that.isShowEdit = true;
			that.isEdit = true;
			let parm = {
				Code: row.PO_Code,
				List: []
			};
			this.$refs.order.clearInput(this.isShowEdit, parm);
		},
		// 新增
		add() {
			let that = this;
			let datetime = (
				new Date().getFullYear() +
				'-' +
				(new Date().getMonth() + 1) +
				'-' +
				new Date().getDate() +
				' ' +
				new Date().getHours() +
				':' +
				new Date().getMinutes() +
				':' +
				new Date().getSeconds()
			).toString();
			that.isEdit = false;
			that.isShowEdit = true;
			that.dataDetail = {
				Head: {},
				Lists: []
			};
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			/*let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac
			};
			that.$http.urlpost('/Inv/UniversalOut/ExportToExecl_Detail', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});*/
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "InvissueManufactureLineInfo",
                fromname: that.$t('getapi[977]'),
                SelectIndex: 0,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
		// 保存
		save() {
			let that = this;
			let parm = that.dataDetail;
			that.$http.urlpost('/Pur/Requisition/SaveData', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
			});
		},
		//
		editInfo1() {},
		editInfo2() {},
		editInfo3() {}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
